/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Warm_Teal_Crane_FeedInputs */

const en_warm_teal_crane_feed = /** @type {(inputs: Warm_Teal_Crane_FeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} manages the following users.`)
};

const de_warm_teal_crane_feed = /** @type {(inputs: Warm_Teal_Crane_FeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} verwaltet die folgenden Benutzer.`)
};

/**
* | output |
* | --- |
* | "{displayName} manages the following users." |
*
* @param {Warm_Teal_Crane_FeedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_teal_crane_feed = /** @type {((inputs: Warm_Teal_Crane_FeedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Teal_Crane_FeedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_teal_crane_feed(inputs)
	return de_warm_teal_crane_feed(inputs)
});